export enum Salutation {
    employeeSalutationsMale = 0,
    employeeSalutationsFemale = 1,
    employeeSalutationsOther = 2,
}
